<app-button (click)="getData()">Get Data</app-button>

<div class="flex gap-5 my-10">
	<app-button (click)="selected = 'institutions'"
		>Financial Insitutions</app-button
	>
	<app-button (click)="selected = 'configs'">LenderConfigurations</app-button>
	<app-button (click)="selected = 'payeeTypes'">PayeeTypes</app-button>
	<app-button (click)="selected = 'all'">All</app-button>
</div>

<textarea
	id="w3review"
	name="w3review"
	class="w-full h-full"
	*ngIf="selected === 'institutions'"
>
	{{ result?.financialInstitutions | json }}
</textarea>
<textarea
	id="w3review"
	name="w3review"
	class="w-full h-full"
	*ngIf="selected === 'configs'"
>
	{{ result?.PayeeTypes | json }}
</textarea>
<textarea
	id="w3review"
	name="w3review"
	class="w-full h-full"
	*ngIf="selected === 'payeeTypes'"
>
	{{ result?.lenderConfigurations | json }}
</textarea>
<textarea
	id="w3review"
	name="w3review"
	class="w-full h-full"
	*ngIf="selected === 'all'"
>
	{{ result | json }}
</textarea>
